// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-item__title[data-v-d908a618]{display:inline-block;margin-bottom:10px}@media (max-width:767px){.news-item__title[data-v-d908a618]{font-size:19px;line-height:22px}}.news-item__tldr[data-v-d908a618]{margin-bottom:15px}@media (max-width:767px){.news-item__tldr[data-v-d908a618]{margin-bottom:10px}}", ""]);
// Exports
module.exports = exports;
